import { Col } from '@wyz/ui';
import { IUserCustomer } from '~/common/types';
import { QuoteProductResult } from '~/purchase/components';
import { IQuoteSetting, IQuoteTyreOffer } from '~/purchase/types';

type Props = {
  items: Array<IQuoteTyreOffer>;
  quoteSetting: IQuoteSetting;
  customer: IUserCustomer;
  showBuyingInfo: boolean;
  requestedQuantity: number;
  onRefreshTyre: (ean: string, quantity: number) => void;
};

function QuoteStandardDisplay({
  items,
  quoteSetting,
  customer,
  showBuyingInfo,
  requestedQuantity,
  onRefreshTyre,
}: Props) {
  return (
    <div className='grid gap-2'>
      {items.map((offer) => (
        <Col
          key={offer.tyre.ean}
          bsPrefix='g-col'
          xs={12}
          sm={12}
          md={6}
          lg={6}
          xl={4}
          xxl={4}
        >
          <QuoteProductResult
            showBuyingInfo={showBuyingInfo}
            tyreOffer={offer}
            defaultQuantity={requestedQuantity}
            customer={customer}
            showBfDiscount={quoteSetting.showBfDiscount ?? true}
            onRefreshTyre={onRefreshTyre}
          />
        </Col>
      ))}
    </div>
  );
}

export default QuoteStandardDisplay;
